import { InjectionKey } from 'vue'

export interface TableSelectProps {
  maxlength?: string | number
  placeholder?: string
  disabled?: boolean
  // readonly?: boolean
  pick: string | string[]
  tag: (row: any) => string
}

export type RowCompletionProvider = (data: any[] | undefined) => Promise<any[] | undefined>

export interface TableSelectContext {
  inputValue: any
  selection: any[] | undefined
  onSelect: (selection: any[], clear?: boolean) => void
  selectDone: () => void
  tag: (row: any) => string
  registerRowCompletionProvider: (provider: RowCompletionProvider) => void
}

export const tableSelectContext: InjectionKey<TableSelectContext> = Symbol('tableSelectContext')
